<template>
  <layout
    :footer="footer"
    :header="header"
    :country="country"
    :show-breadcrumbs="true"
    :hide-usps="isDesktop"
  >
    <div v-if="contentfulPageData.pageTitle" :class="'bg-white'">
      <div class="container mx-auto py-10 px-6">
        <blog-lead
          v-if="sectionBlogLead"
          class="mb-10"
          :title="contentfulPageData.pageTitle"
          :lead-section="sectionBlogLead"
          :is-desktop="isDesktop"
        />

        <section-list :list="list" />
      </div>
    </div>
  </layout>
</template>

<script>
import Layout from '~/components/layout/default'
import { BlogLead } from '~/components/molecules'
import { SectionList } from '~/components/organisms'
import createPageMixin from '~/mixins/page'
import { firstOfCollection, collectionToArray } from '~/utils/collection'
import { contentfulToImage } from '~/utils/image'

export default {
  name: 'BlogPostGmp',
  components: {
    BlogLead,
    Layout,
    SectionList,
  },
  mixins: [createPageMixin({ pageType: 'blog', cloudfrontCache: true })],
  async fetch() {
    const { data } = await this.$contentful('blogPageGmp')({
      slug: `/${this.slug}`,
      locale: this.$store.getters['context/cmsLocale'],
      countryCode: this.$store.getters['context/countryCode'].toLowerCase(),
    })

    const page = firstOfCollection(data.pageCollection)
    if (!page) {
      this.$nuxt.error({ statusCode: 404, message: 'Not found' })
    } else {
      this.contentfulPageData = { ...page, metaTitle: page.pageTitle }
    }
  },
  computed: {
    sectionBlogLead() {
      const lead = this.getSection('SectionBlogLead')
      return {
        ...lead,
        image: contentfulToImage(lead.image),
      }
    },
    list() {
      return collectionToArray(this.contentfulPageData.sectionsCollection)
    },
  },
}
</script>
